/** Copyright (c) 2018, MOBICOOP. All rights reserved. This project is dual
licensed under AGPL and proprietary licence. This program is free software: you
can redistribute it and/or modify it under the terms of the GNU Affero General
Public License as published by the Free Software Foundation, either version 3 of
the License, or (at your option) any later version. This program is distributed
in the hope that it will be useful, but WITHOUT ANY WARRANTY; without even the
implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details. You should have received a
copy of the GNU Affero General Public License along with this program. If not,
see gnu.org/licenses. Licence MOBICOOP described in the file LICENSE
**************************/

<template>
  <div
    class="mc-container mc-user-home"
    :class="{ 'mc-container-right': instance == 'sncf' }"
  >
    <img class="img-background" src="/assets/banner.png" alt="" />
    <div
      v-bind:class="
        seeWelcome ? 'mc-welcome-home' : 'mc-welcome-home is-hidden'
      "
    >
      <ion-icon name="close" item-right @click="closeWelcome()"></ion-icon>
      <h2 v-html="$t('HOME.title', { title })"></h2>
    </div>

    <div
      v-if="instance == 'sncf'"
      class="ion-margin-bottom mc-home-description"
    >
      {{ $t("Home.description") }}
    </div>

    <div
      class="h-100 d-flex align-center justify-center"
      v-if="onlySSO && !!!this.$store.state.userStore.user"
    >
      <ion-icon
        size="large"
        class="rotating"
        color="primary"
        v-if="$store.state.ssoStore.status == 'loading'"
        name="sync"
      ></ion-icon>
      <div class="w-100" v-for="ssoButton in ssoButtons">
        <ion-button
          class="mc-big-button"
          color="success"
          expand="block"
          @click="loginSSO(ssoButton)"
        >
          <ion-icon
            size="large"
            class="rotating"
            v-if="$store.state.userStore.status == 'loading'"
            name="sync"
          ></ion-icon>
          <span
            v-if="$store.state.userStore.status != 'loading'"
            v-bind:style="ssoButton.picto ? 'margin-right: 45px' : ''"
          >
            {{ $t("Login.with") }} {{ ssoButton.service }}
          </span>
          <ion-thumbnail
            v-if="
              ssoButton.picto &&
              $store.state.userStore.status != 'loading' &&
              getPictoUrl(ssoButton)
            "
            slot="end"
            style="position: absolute; right: 0px"
          >
            <img :src="getPictoUrl(ssoButton)" alt="" height="40px" />
          </ion-thumbnail>
        </ion-button>
      </div>
    </div>
    <div
      v-else
      class="mc-user-home-login"
      v-if="!!!this.$store.state.userStore.user"
    >
      <ion-button
        class="mc-big-button"
        color="success"
        expand="block"
        @click="$router.push('login')"
        id="signinButton"
        >{{ $t("HOME.sign-in") }}</ion-button
      >
      <ion-button
        class="mc-big-button"
        :color="instance == 'oise' || instance == 'sncf' ? 'success' : 'light'"
        :class="{
          backgroundWhite: instance == 'sncf',
        }"
        expand="block"
        fill="outline"
        @click="onlySSO ? $router.push('login') : $router.push('register')"
        >{{ $t("HOME.register") }}</ion-button
      >
    </div>

    <div
      class="mc-user-home-profile"
      v-if="!!this.$store.state.userStore.user"
      :class="{ success: instance == 'oise' || instance == 'sncf' }"
    >
      <div class="mc-user-bloc-info">
        <div class="mc-user-image position-relative">
          {{ this.$store.state.userStore.avatars }}
          <ion-thumbnail v-if="!!this.$store.state.userStore.user.avatars">
            <img
              v-if="checkAvatarDefault"
              :src="webURL + user.avatars[0]"
              alt=""
            />
            <img v-else :src="user.avatars[0]" alt="" />
          </ion-thumbnail>
          <ion-icon
            v-if="
              showExperienced && this.$store.state.userStore.user.experienced
            "
            class="experienced"
            name="star"
          ></ion-icon>
        </div>

        <div class="mc-user-info">
          <p>{{ this.$store.state.userStore.user.givenName }}</p>
          <p>{{ this.$store.state.userStore.user.shortFamilyName }}</p>
        </div>
      </div>

      <div class="mc-user-action">
        <ion-icon
          name="create"
          size="large"
          class="pointer mc-user-action-first-action"
          v-on:click="$router.push('profile')"
        />
        <ion-icon
          name="log-out"
          size="large"
          class="pointer logout"
          v-on:click="logout"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.mc-welcome-home {
  text-align: right;
  transition: max-height 0.7s ease, opacity 0.5s ease, padding 0.1s ease;
  max-height: 600px;
  overflow: hidden;

  &.is-hidden {
    max-height: 0px !important;
  }

  h2 {
    font-weight: bold;
    text-align: center;
    margin-bottom: 30%;
  }
}

.backgroundWhite {
  background-color: white;
  border-radius: 30px;
}

.mc-home-description {
  font-family: "Traverse";
  font-size: 18px;
  line-height: 27px;
  letter-spacing: 0em;
  text-align: center;
  color: #4d4f53;
  white-space: break-spaces;
}

.mc-user-action {
  display: flex;
  flex-direction: row;

  .logout {
    margin-top: 2px;
    margin-left: 25px;
  }
}

@media screen and (max-width: 320px) {
  .mc-user-action {
    flex-direction: column;
  }
}

.success {
  color: var(--ion-color-success);
}

.mc-user-home-profile {
  display: flex;
  justify-content: space-between;

  .mc-user-bloc-info {
    display: flex;
  }

  ion-thumbnail {
    --size: 90px;
    --border-radius: 50%;
  }

  .mc-user-info {
    display: flex;
    justify-content: center;
    flex-direction: column;
    margin-left: 20px;

    p {
      margin: 0;
      font-weight: bold;
    }
  }
}

.gratuity-notification-modal {
  --height: auto;
  --max-height: 80%;
  --width: 90%;
  --border-radius: 0 0 15px 15px;
  --box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
}

.gratuity-notification-modal .modal-wrapper {
  border-radius: 0 0 15px 15px;
}
</style>

<script>
import { isPlatform } from "@ionic/core";
import { Browser } from '@capacitor/browser';
import { modalController } from "@ionic/vue";
import GratuityNotificationModal from "../../../Shared/Component/GratuityNotificationModal.component.vue";

export default {
  name: "user-home",
  data() {
    return {
      title: process.env.VUE_APP_NAME,
      instance: process.env.VUE_APP_INSTANCE,
      seeWelcome: localStorage.getItem("seeWelcome") ?? false,
      showExperienced: JSON.parse(process.env.VUE_APP_EXPERIENCED),
      webURL: process.env.VUE_APP_WEB_URL,
      onlySSO: JSON.parse(process.env.VUE_APP_ONLY_SSO),
      sso: JSON.parse(process.env.VUE_APP_SSO),
      ssoButtons: [],
    };
  },
  mounted() {
    if (JSON.parse(process.env.VUE_APP_GRATUITY)) {
      this.showGratuityNotifications();
    }
  },
  created() {
    if (this.sso) {
      this.$store.dispatch("sso_connections").then((res) => {
        if (res && res.length > 0 && !!process.env.VUE_APP_SSO_LOGIN_PROVIDER) {
          const providers = JSON.parse(process.env.VUE_APP_SSO_LOGIN_PROVIDER);
          if (providers && providers.length > 0) {
            this.ssoButtons = res.filter((item) =>
              providers.includes(item.ssoProvider)
            );
          } else {
            this.ssoButtons = res;
          }
        }
      });
    }
  },
  computed: {
    user: {
      get() {
        return this.$store.state.userStore.user;
      },
    },
    checkAvatarDefault() {
      const path = this.user.avatars;
      const avatarDefaultPath = "/images/avatarsDefault/square_100.svg";
      if (path.includes(avatarDefaultPath)) {
        return true;
      }
    },
  },
  methods: {
    async showGratuityNotifications() {
      const user = this.$store.state.userStore.user;
      if (!user || !user.gratuityNotifications || user.gratuityNotifications.length === 0) {
        return;
      }

      for (const notification of user.gratuityNotifications) {
        const modal = await modalController.create({
          component: GratuityNotificationModal,
          componentProps: {
            id: notification.id,
            name: notification.name,
            template: notification.template,
          },
          cssClass: 'gratuity-notification-modal',
          backdropDismiss: false,
        });

        await modal.present();
        await modal.onDidDismiss();
      }
    },
    closeWelcome: function () {
      this.seeWelcome = false;
      localStorage.setItem("seeWelcome", false);
    },

    logout: function () {
      this.$store.dispatch("logout").then(() => {
        // On va authentifier l'appli via un utilisateur anonyme
        this.$store.dispatch("authAnonymousUser");
      });
    },
    loginSSO: function (sso) {
     let uri = sso.uri;
        if (isPlatform(window.document.defaultView, "capacitor")) {
            Browser.open({ url: uri });
        } else {
            window.open(uri, '_self');
        }
    },
    getPictoUrl: function (ssoButton) {
      if (ssoButton.picto) {
        const img = new Image();
        img.src = ssoButton.picto;
        img.onload = () => {
          return process.env.VUE_APP_WEB_URL + ssoButton.picto;
        };
        img.onerror = () => {
          return null;
        };
      }
      return null;
    },
  },
};
</script>
